<template>
  <div>
    <div v-if="simpleView">
      <TileDataContent
        :fids="fids"
        :forecast-label="forecastLabel"
        :dataset="dataset"
        :data-by-id="dataById"
      >
        <template #content-header>
          <TileDataContentHeader>
            <template #first-column>
              <b> {{ $t('components.map.tiles.ElaadForecast.expected') }} </b>
            </template>
            <template #second-column>
              <b> {{ $t('components.map.tiles.ElaadLogistics.amount') }} </b>
            </template>
            <template #third-column>
              <b> {{ $t('components.map.tiles.ElaadForecast.power') }} </b>
            </template>
          </TileDataContentHeader>
        </template>

        <template #content="{ showData }">
          <TileDataContentRowThreeColumn>
            <template #first-column>
              {{ $t('components.map.tiles.TileData.chargingStations') }}
            </template>
            <template #second-column>
              {{
                showData({
                  field: generateFieldName("locaties", year),
                  decimals: 0,
                })
              }}
            </template>
            <template #third-column>
              {{
                showData({
                  field: generateFieldName("kw", year),
                  decimals: 0,
                })
              }}
              kW
            </template>
          </TileDataContentRowThreeColumn>
        </template>
        <template #footer>
          ID: {{ fids[0] }}
        </template>
      </TileDataContent>
    </div>
  </div>
</template>

<script>
import TileDataContent from '@/components/map/tiles/TileDataContent'
import TiledataMixin from '@/mixins/map/tiledata-mixin'
import TileDataContentHeader from '@/components/map/tiles/TileDataContentHeader'
import TileDataContentRowThreeColumn from '@/components/map/tiles/TileDataContentRowThreeColumn'

export default {
  name: 'TileDataBEMoWPersonen',
  components: {
    TileDataContentRowThreeColumn,
    TileDataContentHeader,
    TileDataContent,
  },
  mixins: [TiledataMixin],
  data() {
    return {
      simpleView: true,
    }
  },
  methods: {
    generateFieldName(baseName, year) {
      return `${baseName}_${year}`
    },
  },
}
</script>

<style>
.currentView {
  color: var(--text-muted);
}

.otherView {
  cursor: pointer;

  &:hover {
    color: var(--cta);
  }
}
</style>
